import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	mediaPickerContentTitle: {
		id: 'custom-sites-extensions.spotlight.spotlight-config-panel.media-picker-content-title',
		defaultMessage: 'Media',
		description: 'Title for configuring image in the media picker',
	},
	mediaPickerButtonLabel: {
		id: 'custom-sites-extensions.spotlight.spotlight-config-panel.media-picker-button-label',
		defaultMessage: 'Choose media',
		description: 'Button label for configuring image in the media picker',
	},
	mediaPickerContentHelperMessage: {
		id: 'custom-sites-extensions.spotlight.spotlight-config-panel.mdia-picker-helper-message',
		defaultMessage: 'Choose high resolution images 1200px or wider for best results.',
		description: 'Helper message for configuring image in the media picker',
	},
});
